export default "__VITE_ASSET__7f83afc3__"